const proseStyles = "@layer crnt.components.prose {\n\t@layer base {\n\t\t:host {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n";

export { proseStyles as default };
